export default new class Cookie {

    constructor() {
        this.cookiePolicy = "cookie";
        this.buttonAccept = "cookie__accept";
        this.handler();
    }

    handler() {
        document.addEventListener('DOMContentLoaded', () => {
            this.init();
        });
    }

    init() {

        const cookieBox = $(`.${this.cookiePolicy}`);

        $(`.${this.buttonAccept}`).on('click', function () {

            document.cookie = "CookieBy=ZarosCookie; max-age="+60*60*24*30;

            if (document.cookie) {
                cookieBox.addClass('cookie_hide');
            } else {
                alert("Cookie can't be set!");
            }

        });

        function getCookie(name) {
            let matches = document.cookie.match(new RegExp("(?:^|; )" + name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, '\\$1') + "=([^;]*)"));

            return matches ? decodeURIComponent(matches[1]) : 'undefined';
        }

        if (getCookie('CookieBy') !== 'undefined') {
            cookieBox.addClass('cookie_hide');
        }
    }
}
